var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardClimb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4406_479)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 94,
    height: 94,
    rx: 8,
    fill: "#238856"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1491 39.861L49.032 23.8566C49.8395 22.2171 52.1771 22.2171 52.9847 23.8566L60.8677 39.861L78.5247 42.4125C80.3331 42.6738 81.0557 44.8959 79.747 46.1709L66.9763 58.6145L69.991 76.1977C70.2997 77.9981 68.4092 79.3705 66.793 78.5192L51.0083 70.2049L35.2238 78.5192C33.6068 79.3711 31.7156 77.997 32.0259 76.196L35.0556 58.6145L22.2705 46.1718C20.9608 44.8971 21.6832 42.6739 23.492 42.4125L41.1491 39.861Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1782 69.267C18.4181 68.317 18.5721 66.9305 19.5222 66.1705L26.866 60.2953C27.8161 59.5353 29.2025 59.6892 29.9626 60.6395C30.7227 61.5895 30.5687 62.976 29.6186 63.7362L22.2748 69.6112C21.3247 70.3712 19.9383 70.2172 19.1782 69.267Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4937 66.1703C83.4437 66.9305 83.5979 68.317 82.8377 69.267C82.0774 70.2172 80.6912 70.3712 79.7409 69.6112L72.3972 63.7362C71.4472 62.976 71.293 61.5895 72.0532 60.6395C72.8134 59.6892 74.1996 59.5353 75.1499 60.2953L82.4937 66.1703Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1782 26.8582C18.4181 27.8083 18.5721 29.1947 19.5222 29.9548L26.866 35.8298C27.8161 36.5899 29.2025 36.4359 29.9626 35.4857C30.7227 34.5356 30.5687 33.1492 29.6186 32.3891L22.2748 26.5141C21.3247 25.754 19.9383 25.908 19.1782 26.8582Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4937 29.9548C83.4437 29.1947 83.5979 27.8083 82.8377 26.8582C82.0774 25.908 80.6912 25.754 79.7409 26.5141L72.3972 32.3891C71.4472 33.1492 71.293 34.5356 72.0532 35.4857C72.8134 36.4359 74.1996 36.5899 75.1499 35.8298L82.4937 29.9548Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4406_479",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.717647 0 0 0 0 0.392157 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4406_479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4406_479",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardClimb);
export default __webpack_public_path__ + "static/media/reward-climb.4c13276651c6a289a69483709056bcc3.svg";
export { ForwardRef as ReactComponent };